import React, { useEffect, useState } from 'react'
import {  useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { UseVerifyOtp } from '../hooks/UseVerifyOtp'

export const Mfa = () => {


    const { validateOtp,validateOtpWebsal } = UseVerifyOtp()

    const data = useSelector(state => state.login.data)
    const autenticado = useSelector(state => state.login.autenticado)
    const representante = useSelector(state => state.login.representante)

    const [codigo, setCodigo] = useState('')


    // console.log(representante,'representanterepresentante')

    let navigate = useNavigate()

    useEffect(() => {
        if(!data){
            navigate('/')
        }
    }, [])

    useEffect(() => {
        if(autenticado === 'autorizado' ){
            navigate('/')
        }
    }, [autenticado])
    

    const validate =  async() => {

        const appUser = localStorage.getItem('appUser')

  
        if(appUser === 'representante' ){
            await validateOtpWebsal(codigo)
            return
        }

       await validateOtp(codigo)
    }


   const pressEnter = (e) => {
    if(e.key === 'Enter'){
        validate()
    }

  }

  return (
    <div className='mfaContainer' >

        <h1> Multi Factor Authentication </h1>
           <p> Google Authenticator </p>

        <div className='contenedorMfaInput' >

                    <label> Código MFA </label>
                    <input value={codigo} onKeyPress={pressEnter} onChange={ (e) =>  setCodigo(e.target.value) } />


                    <button type='submit' className='ingresarMfa' onClick={validate} > Ingresar </button>


        </div>

   

    </div>
  )
}
